/* eslint-disable camelcase */
import React from 'react';

import logo_noel2023 from './noel_2023';

export default {
  default: () => {
    return (
      <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      />
    );
  },
  // Main Logo ERMES - blank by default, use 'attrs' to set color
  ermes_logo: options => {
    return (
      <svg viewBox="0 0 341 67" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M289.01 56.21L297.42 46.13C303.25 50.94 309.35 53.99 316.75 53.99C322.58 53.99 326.09 51.68 326.09 47.89V47.71C326.09 44.1 323.87 42.25 313.05 39.48C300.01 36.15 291.6 32.54 291.6 19.69V19.51C291.6 7.77 301.03 0 314.26 0C323.69 0 331.74 2.96 338.3 8.23L330.9 18.96C325.17 14.98 319.53 12.58 314.07 12.58C308.61 12.58 305.75 15.08 305.75 18.22V18.4C305.75 22.65 308.52 24.04 319.71 26.91C332.84 30.33 340.24 35.05 340.24 46.33V46.51C340.24 59.36 330.44 66.58 316.48 66.58C306.67 66.57 296.77 63.14 289.01 56.21Z"
          fill="white"
        />
        <path
          d="M64.47 1.17004H0V14.03H64.47V1.17004Z"
          fill="#FFFFFF"
          {...options}
        />
        <path
          d="M64.47 26.9801H0V39.8401H64.47V26.9801Z"
          fill="#FFFFFF"
          {...options}
        />
        <path
          d="M64.47 52.78H0V65.64H64.47V52.78Z"
          fill="#FFFFFF"
          {...options}
        />
        <path
          d="M282.32 1.17004H217.85V14.03H282.32V1.17004Z"
          fill="#FFFFFF"
          {...options}
        />
        <path
          d="M282.32 26.98H217.85V39.84H282.32V26.98Z"
          fill="#FFFFFF"
          {...options}
        />
        <path
          d="M282.32 52.78H217.85V65.64H282.32V52.78Z"
          fill="#FFFFFF"
          {...options}
        />
        <path
          d="M116.8 44.89L115.77 43.36C120.4 41.53 124.25 38.18 126.7 33.91C128.54 30.7 129.6 26.99 129.6 23.03C129.6 19.07 128.54 15.35 126.7 12.15C123.12 5.93004 116.57 1.63004 108.97 1.21004C108.56 1.19004 108.15 1.17004 107.74 1.17004C107.33 1.17004 106.92 1.18004 106.51 1.21004H90.19V1.17004H77.34V65.64H80.67H90.19V65.58V44.89H101.28L115.24 65.58H130.75L116.8 44.89ZM107.74 14.06C112.69 14.06 116.7 18.08 116.7 23.03C116.7 27.86 112.87 31.79 108.08 31.98L108.12 32.04H92.61H90.19V28.46V21.33V14.08H107.74V14.06Z"
          fill="white"
        />
        <path
          d="M204.09 1.17004H192.08V1.21004H190.67L172.74 28.27L154.82 1.21004H153.4V1.17004H141.4H140.55V1.21004V1.73004V2.95004V65.64H153.4V22.36L165.03 39.92L172.74 51.56L180.45 39.92L192.08 22.36V65.64H204.94V2.95004V1.73004V1.21004V1.17004H204.09Z"
          fill="white"
        />
      </svg>
    );
  },
  ermes_logo_noel2022: options => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        height="70px"
        viewBox="0 0 113.6 112.8"
        xmlSpace="preserve"
      >
        <g>
          <path
            fill="#FFFFFF"
            d="M96.7,64l2.8-3.3c1.9,1.6,3.9,2.6,6.4,2.6c1.9,0,3.1-0.8,3.1-2v-0.1c0-1.2-0.7-1.8-4.3-2.7
		c-4.3-1.1-7.1-2.3-7.1-6.5v-0.1c0-3.9,3.1-6.4,7.5-6.4c3.1,0,5.8,1,7.9,2.7l-2.4,3.5c-1.9-1.3-3.8-2.1-5.6-2.1
		c-1.8,0-2.7,0.8-2.7,1.9v0.1c0,1.4,0.9,1.9,4.6,2.8c4.3,1.1,6.8,2.7,6.8,6.4v0.1c0,4.2-3.2,6.6-7.8,6.6
		C102.5,67.4,99.3,66.3,96.7,64z"
          />
          <path fill="#FFFFFF" d="M22.5,45.8H1.2v4.2h21.3V45.8z" {...options} />
          <path fill="#FFFFFF" d="M22.5,54.3H1.2v4.2h21.3V54.3z" {...options} />
          <path fill="#FFFFFF" d="M22.5,62.9H1.2v4.2h21.3V62.9z" {...options} />
          <path
            fill="#FFFFFF"
            d="M94.5,45.8H73.2v4.2h21.3V45.8z"
            {...options}
          />
          <path
            fill="#FFFFFF"
            d="M94.5,54.3H73.2v4.2h21.3V54.3z"
            {...options}
          />
          <path
            fill="#FFFFFF"
            d="M94.5,62.9H73.2v4.2h21.3V62.9z"
            {...options}
          />
          <path
            fill="#FFFFFF"
            d="M39.8,60.3l-0.3-0.5c1.5-0.6,2.8-1.7,3.6-3.1c0.6-1.1,1-2.3,1-3.6c0-1.3-0.4-2.5-1-3.6
		c-1.2-2.1-3.3-3.5-5.9-3.6c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0-0.4,0H31v0h-4.2v21.3h1.1H31v0v-6.8h3.7l4.6,6.8h5.1L39.8,60.3z
		 M36.8,50.1c1.6,0,3,1.3,3,3c0,1.6-1.3,2.9-2.8,3l0,0h-5.1H31v-1.2v-2.4v-2.4L36.8,50.1L36.8,50.1z"
          />
          <path
            fill="#FFFFFF"
            d="M68.6,45.8h-4v0h-0.5l-5.9,8.9l-5.9-8.9h-0.5v0h-4h-0.3v0V46v0.4v20.7h4.2V52.8l3.8,5.8l2.5,3.8l2.5-3.8
		l3.8-5.8v14.3h4.2V46.4V46v-0.2v0H68.6z"
          />
          <g>
            <rect x="28.4" y="65.4" fill="#3EAC7B" width="0.8" height="1.7" />
            <path fill="#3EAC7B" d="M28.8,63.5l1.6,2.4h-3.1L28.8,63.5z" />
            <path fill="#3EAC7B" d="M28.8,62.8l1.1,1.7h-2.3L28.8,62.8z" />
            <path fill="#3EAC7B" d="M28.8,62.3l0.8,1.3H28L28.8,62.3z" />
          </g>
          <g>
            <rect x="49.4" y="65.4" fill="#3EAC7B" width="0.8" height="1.7" />
            <path fill="#3EAC7B" d="M49.8,63.5l1.6,2.4h-3.1L49.8,63.5z" />
            <path fill="#3EAC7B" d="M49.8,62.8l1.1,1.7h-2.3L49.8,62.8z" />
            <path fill="#3EAC7B" d="M49.8,62.2l0.8,1.3h-1.7L49.8,62.2z" />
          </g>
          <g>
            <rect x="66.4" y="65.4" fill="#3EAC7B" width="0.8" height="1.7" />
            <path fill="#3EAC7B" d="M66.8,63.4l1.6,2.4h-3.1L66.8,63.4z" />
            <path fill="#3EAC7B" d="M66.8,62.8l1.1,1.7h-2.3L66.8,62.8z" />
            <path fill="#3EAC7B" d="M66.8,62.2l0.8,1.3h-1.7L66.8,62.2z" />
          </g>
        </g>
        <path
          fill="#00BDFF"
          d="M51.2,31.7c1.2,0.9,2.3,1.8,3.7,3c0.9-2.9,1-5.1-1.3-7.2c-2.5-2.3-4.9-4.8-7.3-7.3c-0.5-0.5-0.4-1.6-0.6-2.4
	c0.7,0.3,1.6,0.3,2.1,0.8c2.1,2.3,4.1,4.7,6.4,7.4c1.9-3.9,1.4-6.1-1.1-8.6c-1-1-2.2-1.8-3.1-2.9c-0.5-0.6-0.5-1.6-0.8-2.4
	c0.3-0.1,0.6-0.3,0.8-0.4c1.5,1.4,3,2.7,4.7,4.2c1.8-3.7,0.1-6.3-2.7-9c1.4-0.4,2.2-0.6,3.1-0.8c0.3-1.8,0.5-3.6,0.9-5.6
	c3.6,1.3-0.1,6.8,5.7,6.1c-3.2,2.9-4.7,5.5-3,9.2c1.6-1.5,3.1-2.9,4.6-4.2c0.3,0.2,0.6,0.3,0.9,0.5C64,13,63.8,14,63.3,14.6
	c-0.9,1.2-2,2.3-3.2,3.2c-2.4,2-2.1,4.4-1.5,7.6c2.3-2.2,4.2-4.1,6.2-6c0.4-0.4,0.8-0.9,1.2-1.2c0.6-0.3,1.3-0.4,1.9-0.7
	c-0.1,0.7,0,1.7-0.4,2.2c-2.4,2.6-4.8,5.2-7.5,7.5c-2.4,2.1-2.1,4.4-1.4,7.4c4.9-3.6,8.1-8.7,12.9-12c0.3,0.2,0.7,0.5,1,0.7
	c-1.3,5.1-2.6,10.2-3.9,15.2c2.9,0.9,4.6,0,5.3-2.7c0.8-3.1,1.5-6.3,2.4-9.4c0.3-1,1.2-1.9,1.8-2.8c0.1,1.2,0.5,2.4,0.3,3.5
	c-0.5,2.7-1.3,5.3-2.2,8.4c3.2-1.3,5.5-2.2,6-5.4c0.3-2.1,1.3-4.1,2-6.2c0.4,0.1,0.9,0.2,1.3,0.3c-0.3,2-0.5,4-0.8,6.3
	c3.7-0.4,5.4-2.8,6-5.7c1.8,0.3,3.3,0.5,4.6,1c0.5,0.2,0.9,1.4,0.8,2.1c-0.2,1-0.8,2-1.4,3.6c-2.5-0.5-5.6-0.5-8,2.6
	c2.1,0.7,4,1.4,6,2.1c-0.1,0.4-0.1,0.8-0.2,1.1c-1.2-0.1-2.5,0-3.7-0.3c-3.5-0.8-7.1-2.4-10.3,2.1c12,0,23.6,0,35.2,0
	c0,0.3,0,0.6,0,1c-37.4,0-74.7,0-112.1,0c0-0.3,0-0.5,0-0.8c11.1,0,22.3,0,33.4,0c0-0.3,0-0.6,0.1-0.9c-1.9-1.6-3.8-3.2-6.7-2.2
	c-1.6,0.6-3.3,1-5,1.3c-0.6,0.1-1.3-0.4-2-0.6c0.5-0.5,0.9-1.2,1.4-1.4c1.4-0.5,2.9-0.8,4.3-1.2c-2-2.9-4-3.6-8.6-2.5
	c1.1-3.4-1.8-4.3-3.7-5.7c0.7-2.6,2-1.8,3.4-1.2c1,0.4,2.1,2.4,3-0.1c0.7,0.6,2,1,2.2,1.7c0.8,2.8,3.2,3,5.6,4.5
	c-0.4-2.6-0.7-4.6-1-6.6c0.2-0.1,0.5-0.2,0.7-0.3c0.4,0.4,1,0.7,1.2,1.2c0.5,1.2,1,2.5,1.1,3.8c0.4,3.5,2.4,5.4,6.2,6.2
	c-0.8-3.1-1.6-5.9-2.3-8.9c-0.2-0.9,0.2-1.8,0.3-2.8c0.6,0.7,1.4,1.3,1.7,2.2c1,3.2,1.9,6.4,2.7,9.7c0.6,2.8,2.3,3.7,5.3,3.4
	c-1.3-6-2.6-11.8-3.9-17.6c0.2,0,0.4,0,0.6,0c3.2,3.4,6.5,6.8,9.7,10.2c-2.1-0.8-4.1-1.6-6.5-2.5c0.8,3,1.6,6,2.5,9
	c0.1,0.4,0.8,0.9,1.2,0.9c2.1,0.1,4.3,0,6.8,0C54,36.3,50.5,35.1,51.2,31.7z M58,39.2c2.8,0,4.8,0.1,6.7,0c0.5,0,1.4-0.5,1.5-0.9
	c0.9-3,1.7-6,2.6-9.1c-0.2-0.1-0.4-0.2-0.6-0.2C65.1,32.2,61.9,35.4,58,39.2z"
        />
        <path
          fill="#00BDFF"
          d="M61.8,89.5c-1-0.3-2-0.7-3.2-1.1c-0.7,2.3-1.1,4.6,1.1,6.6c1.2,1.1,2.4,2.3,3.4,3.5c0.6,0.7,0.8,1.6,1.2,2.5
	c-0.3,0.2-0.6,0.4-0.9,0.6c-1.5-1.3-3-2.7-4.7-4.2c-1.6,3.8-0.1,6.4,2.7,8.9c-1.4,0.4-2.3,0.7-3.3,1.1c-0.1,1,0,2.1-0.2,3.1
	c-0.2,0.7-0.8,1.3-1.2,1.9c-0.4-0.6-1.2-1.2-1.1-1.7c0.3-2.4-0.4-4-3.1-4.4c1.1-1.5,2.3-2.5,2.8-3.9c0.4-1.4,0.1-3,0.1-5.2
	c-2.1,1.7-3.8,3.1-5.7,4.7c-0.7-2.9,1.2-4,2.7-5.1c3-2.2,3.7-5,2.9-9c-2,1.9-3.8,3.5-5.5,5.2c-0.6,0.6-1.1,1.4-1.8,1.8
	c-0.6,0.4-1.4,0.4-2.1,0.6c0.2-0.7,0.1-1.7,0.5-2.1c2.3-2.4,4.5-4.9,7-7c2.4-2.1,2.7-4.4,1.7-8.1c-4.7,4.7-9,9-13.9,13.8
	c0.6-3.1,1-5.9,1.6-8.7c0.7-3,1.5-5.9,2.2-9c-3-0.6-4.5,0.4-5.2,2.9c-1,3.5-1.9,7-3,10.5c-0.2,0.7-1,1.2-1.5,1.7
	c-0.2-0.7-0.6-1.5-0.4-2.2c0.7-3.1,1.5-6.2,2.4-9.8c-3.3,1.1-5.7,2.3-6.2,5.9c-0.3,2-1.1,3.8-1.7,5.7c-0.5-0.1-0.9-0.2-1.4-0.3
	c0.3-2,0.5-4,0.8-6.2c-3.8,0.3-5.2,3.4-6.4,5.3c-1.9,0.1-3,0.2-4.2,0.3c-1,0.1-2.1,0.1-3.1,0.2c0.5-0.9,0.9-1.8,1.5-2.6
	c0.9-1.2,1.9-2.3,3.2-3.9c2.3,0.6,5,0,7.2-2.7c-2.1-0.8-4.1-1.6-6.1-2.4c0.2-0.4,0.3-0.9,0.5-1.3c2.3,0.6,4.7,1.1,7,1.7
	c2.8,0.7,4.7-0.6,7.1-2.9c-11.7,0-22.6,0-33.6,0c0-0.2,0-0.5,0-0.7c37.1,0,74.2,0,111.3,0c0,0.1,0,0.2,0,0.3c-11.4,0-22.9,0-34.5,0
	c1.5,3.1,3,3.9,6,3.3c1.7-0.3,3.3-0.9,5-1.3c0.9-0.2,1.8,0,2.8,0c0.1,0.4,0.1,0.7,0.2,1.1c-2,0.7-4.1,1.4-6.5,2.2
	c2.9,2.1,5.3,4.3,7.8,2.7c1.5,1.8,2.6,2.9,3.6,4.2c0.5,0.7,0.7,1.5,1.1,2.3c-0.9,0.1-1.8,0.4-2.6,0.1c-1.5-0.5-2.9-2.3-4.4,0.9
	c-1.6-3.3-2.8-6.4-6.9-6.8c0.4,2.1,0.8,4.1,1.2,6.1c-0.3,0.1-0.6,0.3-0.9,0.4c-0.5-0.6-1.2-1.2-1.5-1.9c-0.5-1.1-0.7-2.4-0.9-3.6
	c-0.6-3.2-2.5-5-6.2-6c0.7,2.7,1.4,5.1,1.8,7.5c0.3,1.4,0.1,2.8,0.2,4.2c-2.4-0.2-1.8-2.3-2.2-3.7c-0.9-2.8-1.5-5.7-2.4-8.5
	c-0.7-2.4-2.5-3.4-5.4-2.9c1.1,4.1,2.1,7.9,3.1,11.8c0.3,1.3,0.2,2.7,0.3,4c-1.1-0.7-2.5-1.1-3.4-2c-3.1-3.1-6.1-6.3-9.2-9.5
	c-1.9,2.9-1.5,5,0.3,7.1C60.6,86.6,61.1,88.1,61.8,89.5C61.8,89.5,61.8,89.5,61.8,89.5z M44.8,84c3.5-3.3,6.9-6.4,10.8-10.1
	c-2.8,0-4.8-0.1-6.9,0c-0.5,0-1.2,0.4-1.3,0.8C46.5,77.9,45.6,81,44.8,84z M68.9,84.3c-0.8-3.1-1.6-6.1-2.4-9.1
	c-0.1-0.5-0.9-1.2-1.3-1.2C63,73.9,60.8,74,58.5,74C62.1,77.5,65.3,80.8,68.9,84.3z"
        />
      </svg>
    );
  },
  // -----------
  data: options => {
    return (
      <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13 0H0V2.4375H13V0Z" fill="#FFF" {...options} />
        <path d="M13 4.875H0V8.125H13V4.875Z" fill="#FFF" {...options} />
        <path d="M13 10.5625H0V13H13V10.5625Z" fill="#FFF" {...options} />
      </svg>
    );
  },
  // -----------
  audience: options => {
    return (
      <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.9484 8.76676L9.81724 7.91385L9.46069 7.7188C11.0585 6.19147 11.3146 3.64262 9.97929 1.80454C9.28246 0.845831 8.26149 0.224324 7.10767 0.0491112C5.9506 -0.126101 4.79677 0.171433 3.8601 0.878894C2.92019 1.58966 2.31093 2.63102 2.13915 3.80791C1.96738 4.98812 2.25907 6.16502 2.95267 7.12043C3.10824 7.33531 3.28321 7.53366 3.47119 7.71549L3.15681 7.88409L2.04839 8.76345C0.742239 10.0131 -0.00323055 11.7751 1.05246e-05 13.6V14H1.94466V13.5735C1.84418 12.3338 2.22665 11.1272 3.01747 10.1784C3.80829 9.22959 4.91345 8.65106 6.12886 8.54858C7.34426 8.4494 8.52726 8.83619 9.45745 9.64283C10.3876 10.4495 10.9549 11.5768 11.0554 12.8165C11.0748 13.0677 11.0748 13.3223 11.0554 13.6V14H13V13.6C13 11.7784 12.2545 10.0164 10.9484 8.76676ZM6.5146 7.28903L6.48216 6.95844C5.15656 6.95844 4.06756 5.85757 4.05135 4.50876C4.04487 3.84758 4.28792 3.21948 4.74167 2.74673C5.19542 2.27399 5.80151 2.00621 6.45296 1.9996C6.46269 1.9996 6.47244 1.9996 6.48216 1.9996C7.80776 1.9996 8.89676 3.09384 8.91297 4.44926C8.91945 5.11044 8.67641 5.73856 8.22266 6.21131C7.76891 6.68405 7.16282 6.95183 6.51136 6.95844L6.5146 7.28903Z"
          fill="#FFF"
          {...options}
        />
      </svg>
    );
  },
  // -----------
  activation: options => {
    return (
      <svg
        width="22"
        height="14"
        viewBox="0 0 22 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8257 0C14.4778 0 13.2328 0.433821 12.2158 1.17031L13.9653 2.91973C14.5141 2.60495 15.1477 2.42134 15.8257 2.42134C17.8959 2.42134 19.5787 4.10618 19.5787 6.17441C19.5787 8.24466 17.8939 9.9275 15.8257 9.9275C15.4382 9.9275 15.065 9.86897 14.7118 9.758L12.8736 11.5962C13.7514 12.0764 14.7562 12.3488 15.8257 12.3488C19.2317 12.3488 22 9.57841 22 6.17441C22 2.77041 19.2317 0 15.8257 0Z"
          fill="#FFF"
          {...options}
        />
        <path
          d="M8.96101 0.231934L7.13692 2.07014L10.4219 5.37527H0V7.96812H10.4219L7.13692 11.2753L8.96101 13.1114L15.3574 6.67271L8.96101 0.231934Z"
          fill="#FFF"
          {...options}
        />
      </svg>
    );
  },
  campaign: options => {
    return (
      <svg
        width="22"
        height="14"
        viewBox="0 0 22 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.8257 0C14.4778 0 13.2328 0.433821 12.2158 1.17031L13.9653 2.91973C14.5141 2.60495 15.1477 2.42134 15.8257 2.42134C17.8959 2.42134 19.5787 4.10618 19.5787 6.17441C19.5787 8.24466 17.8939 9.9275 15.8257 9.9275C15.4382 9.9275 15.065 9.86897 14.7118 9.758L12.8736 11.5962C13.7514 12.0764 14.7562 12.3488 15.8257 12.3488C19.2317 12.3488 22 9.57841 22 6.17441C22 2.77041 19.2317 0 15.8257 0Z"
          fill="#FFF"
          {...options}
        />
        <path
          d="M8.96101 0.231934L7.13692 2.07014L10.4219 5.37527H0V7.96812H10.4219L7.13692 11.2753L8.96101 13.1114L15.3574 6.67271L8.96101 0.231934Z"
          fill="#FFF"
          {...options}
        />
      </svg>
    );
  },
  global: options => {
    return (
      <svg
        width="22"
        height="14"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 12.8501C17.21 12.8501 19 11.0601 19 8.8501C19 6.6401 17.21 4.8501 15 4.8501C12.79 4.8501 11 6.6401 11 8.8501C11 11.0601 12.79 12.8501 15 12.8501ZM6 10.8501V7.8501H4V10.8501H1V12.8501H4V15.8501H6V12.8501H9V10.8501H6ZM15 14.8501C12.33 14.8501 7 16.1901 7 18.8501V20.8501H23V18.8501C23 16.1901 17.67 14.8501 15 14.8501Z"
          fill="#FFF"
          {...options}
        />
      </svg>
    );
  },
  // -----------
  funnel: options => {
    return (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 14L9 14L9 12L5 12L5 14Z" fill="#FFF" {...options} />
        <path d="M2 8L12 8L12 6L2 6L2 8Z" fill="#FFF" {...options} />
        <path d="M0 2L14 2L14 0L0 -6.75251e-10L0 2Z" fill="#FFF" {...options} />
      </svg>
    );
  },
  contents: options => {
    return (
      <svg
        width="17"
        height="15"
        viewBox="0 0 17 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 0H14V15H17V0ZM7 4H10V15H7V4ZM0 8H3V15H0V8Z"
          fill="white"
          {...options}
        />
      </svg>
    );
  },
  pml: options => {
    return (
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.492 4.85942C14.4891 4.84429 14.4882 4.82855 14.4823 4.81477C14.4822 4.81446 14.4822 4.81415 14.4821 4.81384L12.8713 1.12719C12.8376 1.04992 12.7613 1 12.677 1H2.32291C2.2386 1 2.16237 1.04992 2.1286 1.12719L0.517815 4.81384C0.517711 4.81415 0.517711 4.81446 0.517608 4.81477C0.511704 4.82845 0.510979 4.84409 0.507975 4.859C0.505489 4.87195 0.500207 4.88469 0.500207 4.89753C0.500207 4.89805 0.5 4.89836 0.5 4.89877V5.89579C0.5 6.28201 0.672451 6.6323 0.95118 6.88825V14.7879C0.95118 14.905 1.04605 15 1.1633 15H13.8367C13.9539 15 14.0488 14.905 14.0488 14.7879V6.88852C14.3274 6.63269 14.5 6.2823 14.5 5.89585V4.89883C14.5 4.89841 14.4998 4.8981 14.4998 4.89769C14.4997 4.88484 14.4945 4.87231 14.492 4.85947L14.492 4.85942ZM13.9637 4.68665H11.7301L10.74 1.42424H12.5382L13.9637 4.68665ZM6.18396 1.42424L5.94511 4.68665H3.71318L4.70326 1.42424H6.18396ZM10.2964 1.42424L11.2865 4.68665H9.04093L8.5675 1.42424H10.2964ZM8.61242 4.68665H6.37033L6.60917 1.42424H8.13896L8.61242 4.68665ZM3.63925 5.11089H5.9301V5.89579C5.9301 6.4432 5.4168 6.88846 4.78354 6.88846C4.15256 6.88846 3.63925 6.4432 3.63925 5.89579V5.11089ZM6.3544 5.11089H8.64546V5.89579C8.64546 6.4432 8.13215 6.88846 7.49868 6.88846C6.8677 6.88846 6.3544 6.4432 6.3544 5.89579V5.11089ZM9.0698 5.11089H11.3607V5.89579C11.3607 6.4432 10.8473 6.88846 10.2139 6.88846C9.58311 6.88846 9.0698 6.4432 9.0698 5.89579V5.11089ZM2.46172 1.42424H4.25997L3.2699 4.68665H1.03622L2.46172 1.42424ZM0.924272 5.11089H3.21512V5.89579C3.21512 6.4432 2.70181 6.88846 2.06856 6.88846C1.43758 6.88846 0.924272 6.4432 0.924272 5.89579V5.11089ZM2.95848 14.5757V9.383H5.98332V14.5757H2.95848ZM13.6247 14.5757H6.40756V9.17088C6.40756 9.05373 6.31268 8.95876 6.19544 8.95876H2.74636C2.62911 8.95876 2.53424 9.05373 2.53424 9.17088V14.5757H1.37545V7.16449C1.58529 7.25843 1.82083 7.3126 2.07086 7.3126C2.64995 7.3126 3.15559 7.02684 3.42727 6.60385C3.69915 7.02674 4.20532 7.3126 4.78616 7.3126C5.36525 7.3126 5.87079 7.02684 6.14246 6.60393C6.41435 7.02682 6.92052 7.3126 7.50125 7.3126C8.08034 7.3126 8.58598 7.02684 8.85766 6.60393C9.12943 7.02682 9.6355 7.3126 10.2163 7.3126C10.7954 7.3126 11.3011 7.02684 11.5727 6.60393C11.8446 7.02682 12.3507 7.3126 12.9314 7.3126C13.1804 7.3126 13.4152 7.25853 13.6246 7.1648L13.6247 14.5757ZM14.0759 5.89574C14.0759 6.44314 13.5626 6.88841 12.9293 6.88841C12.2983 6.88841 11.785 6.44314 11.785 5.89574V5.11084H14.0759V5.89574Z"
          fill="white"
          stroke="white"
          strokeWidth="0.5"
          {...options}
        />
        <path
          d="M12.0487 8.95203H7.87935C7.76255 8.95203 7.66803 9.04724 7.66803 9.16468V12.0994C7.66803 12.2168 7.76255 12.312 7.87935 12.312H12.0487C12.1655 12.312 12.26 12.2168 12.26 12.0994V9.16468C12.26 9.04724 12.1655 8.95203 12.0487 8.95203ZM11.8374 11.8867H8.09067V9.3774H11.8374V11.8867Z"
          fill="white"
          stroke="white"
          strokeWidth="0.5"
          {...options}
        />
      </svg>
    );
  },
  llm: options => {
    return (
      <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.4644 3.13327H0.535564C0.42679 3.13327 0.336143 3.04272 0.336143 2.93405V0.199227C0.336143 0.0905581 0.42679 0 0.535564 0H12.4644C12.5732 0 12.6639 0.0905581 12.6639 0.199227V2.93405C12.6639 3.04272 12.5732 3.13327 12.4644 3.13327Z"
          fill="white"
          {...options}
        />
        <path
          d="M7.7509 8.56672H0.535564C0.42679 8.56672 0.336143 8.47616 0.336143 8.36749V5.63267C0.336143 5.524 0.42679 5.43344 0.535564 5.43344H7.7509C7.85968 5.43344 7.95033 5.524 7.95033 5.63267V8.36749C7.95032 8.47616 7.85968 8.56672 7.7509 8.56672Z"
          fill="white"
          {...options}
        />
        <path
          d="M12.4644 14H0.535564C0.42679 14 0.336143 13.9094 0.336143 13.8008V11.066C0.336143 10.9573 0.42679 10.8667 0.535564 10.8667H12.4644C12.5732 10.8667 12.6639 10.9573 12.6639 11.066V13.8008C12.6639 13.9094 12.5732 14 12.4644 14Z"
          fill="white"
          {...options}
        />
      </svg>
    );
  },
  trash: options => {
    return (
      <svg
        width="11"
        height="14"
        viewBox="0 0 11 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.785714 12.4444C0.785714 13.3 1.49286 14 2.35714 14H8.64286C9.50714 14 10.2143 13.3 10.2143 12.4444V3.11111H0.785714V12.4444ZM11 0.777778H8.25L7.46429 0H3.53571L2.75 0.777778H0V2.33333H11V0.777778Z"
          fill="white"
          {...options}
        />
      </svg>
    );
  },
  add: options => {
    return (
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="13" cy="13" r="13" fill="white" />
        <path
          d="M21 14.1429H14.1429V21H11.8571V14.1429H5V11.8571H11.8571V5H14.1429V11.8571H21V14.1429Z"
          fill="grey"
          {...options}
        />
      </svg>
    );
  },
  darkSwitch: options => {
    return (
      <svg
        width="12"
        height="15"
        viewBox="0 0 12 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 7.5C6 4.16667 3.08785 1.79509 0.564905 0.95C1.6776 0.35 2.94436 0 4.29672 0C8.5592 0 12 3.35 12 7.5C12 11.65 8.5592 15 4.29672 15C2.70471 15 1.23252 14.5333 0 13.7333C2.78454 13.0917 6 10.8333 6 7.5Z"
          fill="#C8C5C5"
          {...options}
        />
      </svg>
    );
  },
  lightSwitch: options => {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...options}
      >
        <path
          d="M7.49927 2.44025C4.7095 2.44025 2.43945 4.71012 2.43945 7.50007C2.43945 10.2898 4.7095 12.5599 7.49927 12.5599C10.289 12.5599 12.5591 10.2898 12.5591 7.50007C12.5591 4.71012 10.2889 2.44025 7.49927 2.44025Z"
          fill="white"
        />
        <path
          d="M6.66016 1.77008H8.34201C8.48296 1.77008 8.54078 1.67015 8.46995 1.54817L7.62929 0.0914833C7.55864 -0.0304944 7.44371 -0.0304944 7.37323 0.0914833L6.53222 1.54817C6.46156 1.67015 6.51884 1.77008 6.66016 1.77008Z"
          fill="white"
        />
        <path
          d="M3.90764 2.95814L5.36432 2.11712C5.4863 2.04683 5.4863 1.93136 5.36432 1.86106L3.90764 1.02005C3.78548 0.94957 3.68555 1.00722 3.68555 1.14799V2.8302C3.68573 2.97097 3.78548 3.02861 3.90764 2.95814Z"
          fill="white"
        />
        <path
          d="M1.86097 5.36347C1.93163 5.48527 2.04674 5.48527 2.11704 5.36347L2.95823 3.9066C3.02853 3.78463 2.97106 3.68488 2.83011 3.68488H1.14826C1.00749 3.68488 0.949845 3.78463 1.02032 3.9066L1.86097 5.36347Z"
          fill="white"
        />
        <path
          d="M1.77008 8.3411V6.65925C1.77008 6.5183 1.66997 6.46084 1.54817 6.53113L0.0914833 7.37215C-0.0304944 7.44262 -0.0304944 7.55773 0.0914833 7.62803L1.54817 8.46904C1.66997 8.5397 1.77008 8.48205 1.77008 8.3411Z"
          fill="white"
        />
        <path
          d="M2.11722 9.63662C2.04692 9.51464 1.93181 9.51464 1.86115 9.63662L1.02032 11.0935C0.949845 11.2153 1.00749 11.3152 1.14826 11.3152H2.83047C2.97124 11.3152 3.02907 11.2153 2.95859 11.0935L2.11722 9.63662Z"
          fill="white"
        />
        <path
          d="M5.36414 12.8827L3.90746 12.0417C3.78548 11.9714 3.68555 12.029 3.68555 12.1698V13.8518C3.68555 13.9928 3.78548 14.0504 3.90746 13.9799L5.36414 13.1391C5.4863 13.0683 5.4863 12.953 5.36414 12.8827Z"
          fill="white"
        />
        <path
          d="M8.34008 13.23H6.65824C6.5171 13.23 6.45964 13.3298 6.53011 13.4517L7.37113 14.9084C7.4416 15.0306 7.55653 15.0306 7.62719 14.9084L8.46784 13.4517C8.53886 13.3298 8.48122 13.23 8.34008 13.23Z"
          fill="white"
        />
        <path
          d="M11.0931 12.0418L9.63627 12.8828C9.51447 12.9531 9.51447 13.0682 9.63627 13.1389L11.0931 13.9799C11.2153 14.0503 11.315 13.9925 11.315 13.8517V12.1695C11.3149 12.0289 11.2153 11.9713 11.0931 12.0418Z"
          fill="white"
        />
        <path
          d="M13.1389 9.63662C13.0684 9.51464 12.9531 9.51464 12.8829 9.63662L12.0417 11.0933C11.9714 11.2155 12.0292 11.3152 12.1698 11.3152H13.852C13.9928 11.3152 14.0506 11.2155 13.9801 11.0933L13.1389 9.63662Z"
          fill="white"
        />
        <path
          d="M14.9091 7.37217L13.4522 6.53133C13.3302 6.46067 13.2305 6.51832 13.2305 6.65909V8.34112C13.2305 8.48189 13.3302 8.53954 13.4522 8.46924L14.9091 7.62823C15.031 7.55775 15.031 7.44264 14.9091 7.37217Z"
          fill="white"
        />
        <path
          d="M12.8831 5.36347C12.9534 5.48563 13.0687 5.48563 13.1391 5.36347L13.98 3.90678C14.0506 3.78481 13.9926 3.68488 13.852 3.68488H12.1698C12.029 3.68488 11.9714 3.78481 12.0417 3.90678L12.8831 5.36347Z"
          fill="white"
        />
        <path
          d="M9.63641 2.11712L11.0929 2.95814C11.2152 3.02843 11.315 2.97079 11.315 2.83002V1.14799C11.315 1.00722 11.2152 0.94957 11.0929 1.02005L9.63641 1.86088C9.51443 1.93136 9.51443 2.04665 9.63641 2.11712Z"
          fill="white"
        />
      </svg>
    );
  },
  caretDown: options => {
    return (
      <svg
        width="13"
        height="13"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.4955 6.0125L7.9105 6.6105C7.4425 7.0785 7.15 7.475 7.15 8.45H5.85V8.125C5.85 7.4035 6.1425 6.7535 6.6105 6.2855L7.4165 5.4665C7.657 5.2325 7.8 4.9075 7.8 4.55C7.8 3.8285 7.215 3.25 6.5 3.25C6.15522 3.25 5.82456 3.38696 5.58076 3.63076C5.33696 3.87456 5.2 4.20522 5.2 4.55H3.9C3.9 3.86044 4.17393 3.19912 4.66152 2.71152C5.14912 2.22393 5.81044 1.95 6.5 1.95C7.18956 1.95 7.85088 2.22393 8.33848 2.71152C8.82607 3.19912 9.1 3.86044 9.1 4.55C9.1 5.122 8.866 5.6355 8.4955 6.0125ZM7.15 11.05H5.85V9.75H7.15V11.05ZM6.5 0C5.64641 0 4.80117 0.168128 4.01256 0.494783C3.22394 0.821439 2.50739 1.30023 1.90381 1.90381C0.684819 3.12279 0 4.77609 0 6.5C0 8.22391 0.684819 9.87721 1.90381 11.0962C2.50739 11.6998 3.22394 12.1786 4.01256 12.5052C4.80117 12.8319 5.64641 13 6.5 13C8.22391 13 9.87721 12.3152 11.0962 11.0962C12.3152 9.87721 13 8.22391 13 6.5C13 2.9055 10.075 0 6.5 0Z"
          fill="#EBEFF2"
          {...options}
        />
      </svg>
    );
  },
  arrowSimple: options => {
    return (
      <svg
        width="13"
        height="17"
        viewBox="0 0 13 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.784813 0.531998H3.81081L12.3448 8.42L3.81081 16.308H0.784813L9.35281 8.42L0.784813 0.531998Z"
          fill="white"
          {...options}
        />
      </svg>
    );
  },
  arrowDown: options => {
    return (
      <svg width="24" height="18" xmlns="http://www.w3.org/2000/svg">
        <title />
        <g>
          <title>background</title>
          <rect
            fill="none"
            id="canvas_background"
            height="20"
            width="26"
            y="-1"
            x="-1"
          />
        </g>
        <g>
          <title>Layer 1</title>
          <path
            stroke="null"
            fill="#ffffff"
            id="svg_1"
            d="m10.735932,1.683119l0,12.774569l-4.36,-2.923814a1,0.805458 0 0 0 -1.28,1.240406l6,4.027292l0.15,0.072491l0.13,0.056382a1,0.805458 0 0 0 0.36,0.056382l0,0a1,0.805458 0 0 0 0.36,-0.056382l0.13,-0.056382l0.15,-0.072491l6,-4.027292a1,0.805458 0 0 0 0.36,-0.620203a1,0.805458 0 0 0 -0.23,-0.515493a1,0.805458 0 0 0 -1.41,-0.10471l-4.36,2.923814l0,-12.774569a1,0.805458 0 0 0 -2,0z"
            className="cls-1"
            {...options}
          />
          <path
            stroke="null"
            fill="#fcfcfc"
            id="svg_2"
            d="m12.095932,16.930245l0.13,-0.056582l0.15,-0.072749l6,-4.041596a1,0.808319 0 0 0 0.36,-0.622406a1,0.808319 0 0 0 -0.23,-0.517324a1,0.808319 0 0 0 -1.41,-0.105082l-4.36,2.934199l0,-12.819944a1,0.808319 0 0 0 -1,-0.808319l0,16.166385l0,0a1,0.808319 0 0 0 0.36,-0.056582z"
            className="cls-2"
            {...options}
          />
        </g>
      </svg>
    );
  },
  arrowRightLarge: options => {
    return (
      <svg
        width="19"
        height="68"
        viewBox="0 0 19 68"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.4592 32.6444L1.94849 0.566459C1.55975 -0.18882 0.936287 -0.18882 0.547541 0.566459C0.158795 1.32174 0.158795 2.53303 0.547541 3.28831L16.3541 33.9982L0.547541 64.7081C0.158795 65.4634 0.158795 66.6747 0.547541 67.43C0.738247 67.8005 0.994966 68 1.24435 68C1.49373 68 1.75045 67.8147 1.94116 67.43L18.4519 35.352C18.8406 34.611 18.8406 33.3854 18.4592 32.6444Z"
          fill="#3300FF"
          {...options}
        />
      </svg>
    );
  },
  arrowVerticalDouble: options => {
    return (
      <svg
        width="8"
        height="49"
        viewBox="0 0 8 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.35355 0.646416C4.15829 0.451153 3.84171 0.451153 3.64645 0.646416L0.464466 3.8284C0.269204 4.02366 0.269204 4.34024 0.464466 4.5355C0.659728 4.73077 0.976311 4.73077 1.17157 4.5355L4 1.70708L6.82843 4.5355C7.02369 4.73077 7.34027 4.73077 7.53553 4.5355C7.7308 4.34024 7.7308 4.02366 7.53553 3.8284L4.35355 0.646416ZM4.5 47.5251L4.5 0.999969H3.5L3.5 47.5251H4.5Z"
          fill="#4C4E58"
          {...options}
        />
        <path
          d="M3.64645 48.8096C3.84171 49.0049 4.15829 49.0049 4.35355 48.8096L7.53553 45.6277C7.7308 45.4324 7.7308 45.1158 7.53553 44.9206C7.34027 44.7253 7.02369 44.7253 6.82843 44.9206L4 47.749L1.17157 44.9206C0.976311 44.7253 0.659728 44.7253 0.464466 44.9206C0.269204 45.1158 0.269204 45.4324 0.464466 45.6277L3.64645 48.8096ZM3.5 1.93091L3.5 48.4561H4.5L4.5 1.93091H3.5Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  arrowVerticalDoubleLong: options => {
    return (
      <svg
        width="8"
        height="89"
        viewBox="0 0 8 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.35355 0.646416C4.15829 0.451153 3.84171 0.451153 3.64645 0.646416L0.464466 3.8284C0.269204 4.02366 0.269204 4.34024 0.464466 4.5355C0.659728 4.73077 0.976311 4.73077 1.17157 4.5355L4 1.70708L6.82843 4.5355C7.02369 4.73077 7.34027 4.73077 7.53553 4.5355C7.7308 4.34024 7.7308 4.02366 7.53553 3.8284L4.35355 0.646416ZM4.5 47.5251L4.5 0.999969H3.5L3.5 47.5251H4.5Z"
          fill="#4C4E58"
          {...options}
        />
        <path
          d="M3.64645 48.8096C3.84171 49.0049 4.15829 49.0049 4.35355 48.8096L7.53553 45.6277C7.7308 45.4324 7.7308 45.1158 7.53553 44.9206C7.34027 44.7253 7.02369 44.7253 6.82843 44.9206L4 47.749L1.17157 44.9206C0.976311 44.7253 0.659728 44.7253 0.464466 44.9206C0.269204 45.1158 0.269204 45.4324 0.464466 45.6277L3.64645 48.8096ZM3.5 1.93091L3.5 48.4561H4.5L4.5 1.93091H3.5Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  arrowRight: options => {
    return (
      <svg
        width="16"
        height="8"
        viewBox="0 0 20 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.3536 4.35355C19.5488 4.15829 19.5488 3.84171 19.3536 3.64645L16.1716 0.464466C15.9763 0.269204 15.6597 0.269204 15.4645 0.464466C15.2692 0.659728 15.2692 0.976311 15.4645 1.17157L18.2929 4L15.4645 6.82843C15.2692 7.02369 15.2692 7.34027 15.4645 7.53553C15.6597 7.7308 15.9763 7.7308 16.1716 7.53553L19.3536 4.35355ZM0 4.5L19 4.5V3.5L0 3.5L0 4.5Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  group: options => {
    return (
      <svg
        width="22"
        height="14"
        viewBox="0 0 22 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 6C16.66 6 17.99 4.66 17.99 3C17.99 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 4.66 13.34 6 15 6ZM7 6C8.66 6 9.99 4.66 9.99 3C9.99 1.34 8.66 0 7 0C5.34 0 4 1.34 4 3C4 4.66 5.34 6 7 6ZM7 8C4.67 8 0 9.17 0 11.5V14H14V11.5C14 9.17 9.33 8 7 8ZM15 8C14.71 8 14.38 8.02 14.03 8.05C15.19 8.89 16 10.02 16 11.5V14H22V11.5C22 9.17 17.33 8 15 8Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  mediaDs: options => {
    return (
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 4H12.41L15.7 0.71L15 0L11 4L7 0L6.29 0.71L9.59 4H2C0.9 4 0 4.89 0 6V18C0 19.1 0.9 20 2 20H20C21.1 20 22 19.1 22 18V6C22 4.89 21.1 4 20 4ZM20 18H2V6H20V18ZM8 8V16L15 12L8 8Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  export: options => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM17 13L12 18L7 13H10V9H14V13H17Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  category: options => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM6 15.5C4.62 15.5 3.5 14.38 3.5 13C3.5 11.62 4.62 10.5 6 10.5C7.38 10.5 8.5 11.62 8.5 13C8.5 14.38 7.38 15.5 6 15.5ZM7.5 6C7.5 4.62 8.62 3.5 10 3.5C11.38 3.5 12.5 4.62 12.5 6C12.5 7.38 11.38 8.5 10 8.5C8.62 8.5 7.5 7.38 7.5 6ZM14 15.5C12.62 15.5 11.5 14.38 11.5 13C11.5 11.62 12.62 10.5 14 10.5C15.38 10.5 16.5 11.62 16.5 13C16.5 14.38 15.38 15.5 14 15.5Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  critere: options => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 20H12.5V0H7.5V20ZM0 20H5V10H0V20ZM15 6.25V20H20V6.25H15Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  setting: options => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.1401 12.9359C19.1761 12.6359 19.2001 12.3239 19.2001 11.9999C19.2001 11.6759 19.1761 11.3639 19.1281 11.0639L21.1561 9.4799C21.3361 9.3359 21.3841 9.0719 21.2761 8.8679L19.3561 5.5439C19.2361 5.3279 18.9841 5.2559 18.7681 5.3279L16.3801 6.2879C15.8761 5.9039 15.3481 5.5919 14.7601 5.3519L14.4001 2.8079C14.3641 2.5679 14.1601 2.3999 13.9201 2.3999H10.0801C9.84011 2.3999 9.64811 2.5679 9.61211 2.8079L9.25211 5.3519C8.66411 5.5919 8.12411 5.9159 7.63211 6.2879L5.24411 5.3279C5.02811 5.2439 4.77611 5.3279 4.65611 5.5439L2.73611 8.8679C2.61611 9.0839 2.66411 9.3359 2.85611 9.4799L4.88411 11.0639C4.83611 11.3639 4.80011 11.6879 4.80011 11.9999C4.80011 12.3119 4.82411 12.6359 4.87211 12.9359L2.84411 14.5199C2.66411 14.6639 2.61611 14.9279 2.72411 15.1319L4.64411 18.4559C4.76411 18.6719 5.01611 18.7439 5.23211 18.6719L7.62011 17.7119C8.12411 18.0959 8.65211 18.4079 9.24011 18.6479L9.60011 21.1919C9.64811 21.4319 9.84011 21.5999 10.0801 21.5999H13.9201C14.1601 21.5999 14.3641 21.4319 14.3881 21.1919L14.7481 18.6479C15.3361 18.4079 15.8761 18.0839 16.3681 17.7119L18.7561 18.6719C18.9721 18.7559 19.2241 18.6719 19.3441 18.4559L21.2641 15.1319C21.3841 14.9159 21.3361 14.6639 21.1441 14.5199L19.1401 12.9359ZM12.0001 15.5999C10.0201 15.5999 8.40011 13.9799 8.40011 11.9999C8.40011 10.0199 10.0201 8.3999 12.0001 8.3999C13.9801 8.3999 15.6001 10.0199 15.6001 11.9999C15.6001 13.9799 13.9801 15.5999 12.0001 15.5999Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  activationShop: options => {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.9885 6.51345C20.9844 6.49185 20.9832 6.46936 20.9748 6.44968C20.9746 6.44923 20.9746 6.44879 20.9745 6.44835L18.6733 1.1817C18.6251 1.07132 18.5162 1 18.3958 1H3.60416C3.48371 1 3.37481 1.07132 3.32658 1.1817L1.02545 6.44835C1.0253 6.44879 1.0253 6.44923 1.02515 6.44968C1.01672 6.46921 1.01568 6.49155 1.01139 6.51286C1.00784 6.53135 1.0003 6.54955 1.0003 6.5679C1.0003 6.56864 1 6.56908 1 6.56968V7.99399C1 8.54573 1.24636 9.04614 1.64454 9.41179V20.697C1.64454 20.8643 1.78008 21 1.94757 21H20.0524C20.2199 21 20.3555 20.8643 20.3555 20.697V9.41217C20.7535 9.0467 21 8.54615 21 7.99406V6.56975C21 6.56916 20.9997 6.56872 20.9997 6.56812C20.9996 6.54978 20.9922 6.53187 20.9886 6.51353L20.9885 6.51345ZM20.2339 6.26665H17.0429L15.6286 1.60606H18.1975L20.2339 6.26665ZM9.11994 1.60606L8.77874 6.26665H5.59026L7.00465 1.60606H9.11994ZM14.9949 1.60606L16.4093 6.26665H13.2013L12.525 1.60606H14.9949ZM12.5892 6.26665H9.38619L9.72739 1.60606H11.9128L12.5892 6.26665ZM5.48465 6.87271H8.75729V7.99399C8.75729 8.77599 8.024 9.41209 7.11934 9.41209C6.21794 9.41209 5.48465 8.77599 5.48465 7.99399V6.87271ZM9.36342 6.87271H12.6364V7.99399C12.6364 8.77599 11.9031 9.41209 10.9981 9.41209C10.0967 9.41209 9.36342 8.77599 9.36342 7.99399V6.87271ZM13.2426 6.87271H16.5152V7.99399C16.5152 8.77599 15.7819 9.41209 14.877 9.41209C13.9759 9.41209 13.2426 8.77599 13.2426 7.99399V6.87271ZM3.80246 1.60606H6.37139L4.957 6.26665H1.76603L3.80246 1.60606ZM1.6061 6.87271H4.87874V7.99399C4.87874 8.77599 4.14545 9.41209 3.24079 9.41209C2.3394 9.41209 1.6061 8.77599 1.6061 7.99399V6.87271ZM4.51211 20.3939V12.9757H8.83331V20.3939H4.51211ZM19.7496 20.3939H9.43937V12.6727C9.43937 12.5053 9.30384 12.3697 9.13634 12.3697H4.20909C4.04159 12.3697 3.90606 12.5053 3.90606 12.6727V20.3939H2.25065V9.80641C2.55042 9.94061 2.88689 10.018 3.24409 10.018C4.07136 10.018 4.7937 9.60978 5.18181 9.0055C5.57022 9.60962 6.29332 10.018 7.12309 10.018C7.95036 10.018 8.67255 9.60978 9.06066 9.00561C9.44907 9.60974 10.1722 10.018 11.0018 10.018C11.8291 10.018 12.5514 9.60978 12.9395 9.00561C13.3278 9.60974 14.0507 10.018 14.8805 10.018C15.7078 10.018 16.4301 9.60978 16.8182 9.00561C17.2066 9.60974 17.9296 10.018 18.7592 10.018C19.1149 10.018 19.4503 9.94076 19.7494 9.80685L19.7496 20.3939ZM20.3941 7.99391C20.3941 8.77592 19.6608 9.41202 18.7562 9.41202C17.8548 9.41202 17.1215 8.77592 17.1215 7.99391V6.87263H20.3941V7.99391Z"
          fill="#4C4E58"
          stroke="#4C4E58"
          {...options}
        />
        <path
          d="M17.4981 12.3599H11.5419C11.375 12.3599 11.24 12.4959 11.24 12.6637V16.8561C11.24 17.0238 11.375 17.1599 11.5419 17.1599H17.4981C17.665 17.1599 17.8 17.0238 17.8 16.8561V12.6637C17.8 12.4959 17.665 12.3599 17.4981 12.3599ZM17.1962 16.5523H11.8438V12.9675H17.1962V16.5523Z"
          fill="#4C4E58"
          stroke="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  menuInfo: options => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.9 6.5H13.1V8.7H10.9V6.5ZM10.9 10.9H13.1V17.5H10.9V10.9ZM12 1C5.928 1 1 5.928 1 12C1 18.072 5.928 23 12 23C18.072 23 23 18.072 23 12C23 5.928 18.072 1 12 1ZM12 20.8C7.149 20.8 3.2 16.851 3.2 12C3.2 7.149 7.149 3.2 12 3.2C16.851 3.2 20.8 7.149 20.8 12C20.8 16.851 16.851 20.8 12 20.8Z"
          fill="#383B50"
          {...options}
        />
      </svg>
    );
  },
  media: options => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 3H4C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H20C21.1046 17 22 16.1046 22 15V5C22 3.89543 21.1046 3 20 3Z"
          stroke={options.fill || '#4C4E58'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 21H16"
          stroke={options.fill || '#4C4E58'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 17V21"
          stroke={options.fill || '#4C4E58'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
  canal: options => {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.2725 4L16.5625 6.29L13.6825 9.17L15.1025 10.59L17.9825 7.71L20.2725 10V4H14.2725ZM10.2725 4H4.27246V10L6.56246 7.71L11.2725 12.41V20H13.2725V11.59L7.98246 6.29L10.2725 4Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  txCanal: options => {
    return (
      <svg
        width="28"
        height="31"
        viewBox="0 0 28 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.2725 4L16.5625 6.29L13.6825 9.17L15.1025 10.59L17.9825 7.71L20.2725 10V4H14.2725ZM10.2725 4H4.27246V10L6.56246 7.71L11.2725 12.41V20H13.2725V11.59L7.98246 6.29L10.2725 4Z"
          fill="#4C4E58"
          {...options}
        />
        <path
          d="M16.63 16.705C16.63 15.975 16.84 15.405 17.26 14.995C17.69 14.575 18.24 14.365 18.91 14.365C19.58 14.365 20.125 14.575 20.545 14.995C20.975 15.405 21.19 15.975 21.19 16.705C21.19 17.435 20.975 18.01 20.545 18.43C20.125 18.85 19.58 19.06 18.91 19.06C18.24 19.06 17.69 18.85 17.26 18.43C16.84 18.01 16.63 17.435 16.63 16.705ZM25.78 14.56L19.795 25H18.115L24.1 14.56H25.78ZM18.91 15.4C18.28 15.4 17.965 15.835 17.965 16.705C17.965 17.585 18.28 18.025 18.91 18.025C19.21 18.025 19.44 17.92 19.6 17.71C19.77 17.49 19.855 17.155 19.855 16.705C19.855 15.835 19.54 15.4 18.91 15.4ZM22.735 22.84C22.735 22.11 22.945 21.54 23.365 21.13C23.795 20.71 24.345 20.5 25.015 20.5C25.675 20.5 26.215 20.71 26.635 21.13C27.065 21.54 27.28 22.11 27.28 22.84C27.28 23.57 27.065 24.145 26.635 24.565C26.215 24.985 25.675 25.195 25.015 25.195C24.345 25.195 23.795 24.985 23.365 24.565C22.945 24.145 22.735 23.57 22.735 22.84ZM25 21.535C24.37 21.535 24.055 21.97 24.055 22.84C24.055 23.71 24.37 24.145 25 24.145C25.63 24.145 25.945 23.71 25.945 22.84C25.945 21.97 25.63 21.535 25 21.535Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  txFunnel: options => {
    return (
      <svg
        width="22"
        height="27"
        viewBox="0 0 22 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.41016 13.7947H9.66016V11.0447H4.41016V13.7947Z"
          fill="#4C4E58"
          {...options}
        />
        <path
          d="M2.41016 8.29468L11.6602 8.29468V5.54468L2.41016 5.54468V8.29468Z"
          fill="#4C4E58"
          {...options}
        />
        <path
          d="M0.160156 2.79468L13.9102 2.79468V0.044678L0.160156 0.044678V2.79468Z"
          fill="#4C4E58"
          {...options}
        />
        <path
          d="M10.63 12.705C10.63 11.975 10.84 11.405 11.26 10.995C11.69 10.575 12.24 10.365 12.91 10.365C13.58 10.365 14.125 10.575 14.545 10.995C14.975 11.405 15.19 11.975 15.19 12.705C15.19 13.435 14.975 14.01 14.545 14.43C14.125 14.85 13.58 15.06 12.91 15.06C12.24 15.06 11.69 14.85 11.26 14.43C10.84 14.01 10.63 13.435 10.63 12.705ZM19.78 10.56L13.795 21H12.115L18.1 10.56H19.78ZM12.91 11.4C12.28 11.4 11.965 11.835 11.965 12.705C11.965 13.585 12.28 14.025 12.91 14.025C13.21 14.025 13.44 13.92 13.6 13.71C13.77 13.49 13.855 13.155 13.855 12.705C13.855 11.835 13.54 11.4 12.91 11.4ZM16.735 18.84C16.735 18.11 16.945 17.54 17.365 17.13C17.795 16.71 18.345 16.5 19.015 16.5C19.675 16.5 20.215 16.71 20.635 17.13C21.065 17.54 21.28 18.11 21.28 18.84C21.28 19.57 21.065 20.145 20.635 20.565C20.215 20.985 19.675 21.195 19.015 21.195C18.345 21.195 17.795 20.985 17.365 20.565C16.945 20.145 16.735 19.57 16.735 18.84ZM19 17.535C18.37 17.535 18.055 17.97 18.055 18.84C18.055 19.71 18.37 20.145 19 20.145C19.63 20.145 19.945 19.71 19.945 18.84C19.945 17.97 19.63 17.535 19 17.535Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  offlineCPM: options => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.125 15.0208C11.7654 15.0208 10.59 14.2517 10.005 13.125H13.125V12.0417H9.6475C9.62042 11.8629 9.60417 11.6842 9.60417 11.5C9.60417 11.3158 9.62042 11.1371 9.6475 10.9583H13.125V9.875H10.005C10.59 8.74833 11.7708 7.97917 13.125 7.97917C13.9971 7.97917 14.7987 8.29875 15.4163 8.82958L16.375 7.87083C15.5138 7.09625 14.3708 6.625 13.125 6.625C11.0017 6.625 9.20333 7.98458 8.53167 9.875H6.625V10.9583H8.2825C8.26083 11.1371 8.25 11.3158 8.25 11.5C8.25 11.6842 8.26083 11.8629 8.2825 12.0417H6.625V13.125H8.53167C9.20333 15.0154 11.0017 16.375 13.125 16.375C14.3763 16.375 15.5138 15.9038 16.375 15.1292L15.4108 14.1704C14.7987 14.7013 14.0025 15.0208 13.125 15.0208Z"
          fill="#4C4E58"
          {...options}
        />
        <path
          d="M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  euro: options => {
    return (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.2725 18.5C12.7625 18.5 10.5925 17.08 9.51246 15H15.2725V13H8.85246C8.80246 12.67 8.77246 12.34 8.77246 12C8.77246 11.66 8.80246 11.33 8.85246 11H15.2725V9H9.51246C10.5925 6.92 12.7725 5.5 15.2725 5.5C16.8825 5.5 18.3625 6.09 19.5025 7.07L21.2725 5.3C19.6825 3.87 17.5725 3 15.2725 3C11.3525 3 8.03246 5.51 6.79246 9H3.27246V11H6.33246C6.29246 11.33 6.27246 11.66 6.27246 12C6.27246 12.34 6.29246 12.67 6.33246 13H3.27246V15H6.79246C8.03246 18.49 11.3525 21 15.2725 21C17.5825 21 19.6825 20.13 21.2725 18.7L19.4925 16.93C18.3625 17.91 16.8925 18.5 15.2725 18.5Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  computePartial: () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="14.1426"
          width="20"
          height="20"
          transform="rotate(45 14.1426 0)"
          fill="#EF7D25"
        />
        <path
          d="M15.0342 8.35L14.7942 15.595H13.0242L12.7692 8.35H15.0342ZM13.9542 19.105C13.5742 19.105 13.2592 18.99 13.0092 18.76C12.7692 18.52 12.6492 18.225 12.6492 17.875C12.6492 17.525 12.7692 17.235 13.0092 17.005C13.2592 16.765 13.5742 16.645 13.9542 16.645C14.3242 16.645 14.6292 16.765 14.8692 17.005C15.1092 17.235 15.2292 17.525 15.2292 17.875C15.2292 18.225 15.1092 18.52 14.8692 18.76C14.6292 18.99 14.3242 19.105 13.9542 19.105Z"
          fill="white"
        />
      </svg>
    );
  },
  sun: options => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.23636 3.94541L3.6 2.31814L2.31818 3.59996L3.94545 5.22723L5.23636 3.94541ZM2.72727 9.09086H0V10.909H2.72727V9.09086ZM10.9091 0.0454102H9.09091V2.72723H10.9091V0.0454102ZM17.6818 3.59996L16.4 2.31814L14.7727 3.94541L16.0545 5.22723L17.6818 3.59996ZM14.7636 16.0545L16.3909 17.6909L17.6727 16.409L16.0364 14.7818L14.7636 16.0545ZM17.2727 9.09086V10.909H20V9.09086H17.2727ZM10 4.54541C6.99091 4.54541 4.54545 6.99086 4.54545 9.99996C4.54545 13.009 6.99091 15.4545 10 15.4545C13.0091 15.4545 15.4545 13.009 15.4545 9.99996C15.4545 6.99086 13.0091 4.54541 10 4.54541ZM9.09091 19.9545H10.9091V17.2727H9.09091V19.9545ZM2.31818 16.4L3.6 17.6818L5.22727 16.0454L3.94545 14.7636L2.31818 16.4Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  user: options => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 2.375C11.45 2.375 12.625 3.55 12.625 5C12.625 6.45 11.45 7.625 10 7.625C8.55 7.625 7.375 6.45 7.375 5C7.375 3.55 8.55 2.375 10 2.375ZM10 13.625C13.7125 13.625 17.625 15.45 17.625 16.25V17.625H2.375V16.25C2.375 15.45 6.2875 13.625 10 13.625ZM10 0C7.2375 0 5 2.2375 5 5C5 7.7625 7.2375 10 10 10C12.7625 10 15 7.7625 15 5C15 2.2375 12.7625 0 10 0ZM10 11.25C6.6625 11.25 0 12.925 0 16.25V20H20V16.25C20 12.925 13.3375 11.25 10 11.25Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  tagfunnel: options => {
    return (
      <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.31579 14L9.47368 10.9053C9.06316 10.8632 8.7579 10.8421 8.42105 10.8421C5.61053 10.8421 0 12.2526 0 15.0526V17.1579H9.47368L6.31579 14ZM8.42105 8.73685C10.7474 8.73685 12.6316 6.85264 12.6316 4.52632C12.6316 2.20001 10.7474 0.315796 8.42105 0.315796C6.09474 0.315796 4.21053 2.20001 4.21053 4.52632C4.21053 6.85264 6.09474 8.73685 8.42105 8.73685Z"
          fill="#4C4E58"
          {...options}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1263 17.6842L9.47369 14L10.9474 12.5158L13.1263 14.7053L18.5263 9.26315L20 10.7474L13.1263 17.6842Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  activatedAudiences: options => {
    return (
      <svg
        width="22"
        height="16"
        viewBox="0 0 22 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.5924 7.44165H17.9406C17.7155 7.44165 17.533 7.68348 17.533 7.98183C17.533 8.28017 17.7154 8.522 17.9406 8.522H20.5924C20.8175 8.522 21 8.28017 21 7.98183C21 7.68348 20.8175 7.44165 20.5924 7.44165Z"
          fill="#4C4E58"
          stroke="#4C4E58"
          {...options}
        />
        <path
          d="M17.5741 5.78181C17.6751 5.78078 17.7721 5.72931 17.8457 5.6379L20.1443 2.80768C20.2432 2.72012 20.3082 2.57991 20.3225 2.4237C20.3368 2.26736 20.299 2.11058 20.2189 1.99432C20.1388 1.87806 20.0243 1.81387 19.9057 1.8186C19.7869 1.82348 19.6756 1.89655 19.601 2.01902L17.3051 4.84923H17.305C17.2257 4.94671 17.179 5.08174 17.1748 5.22492C17.1708 5.36809 17.2098 5.50757 17.2833 5.61258C17.3594 5.71774 17.464 5.77868 17.5741 5.78179L17.5741 5.78181Z"
          fill="#4C4E58"
          stroke="#4C4E58"
          {...options}
        />
        <path
          d="M17.9026 10.3619C17.824 10.2619 17.7185 10.2078 17.6095 10.2116C17.5006 10.2155 17.3973 10.277 17.3229 10.3824C17.2485 10.4879 17.209 10.6284 17.2132 10.7726C17.2174 10.917 17.2652 11.0531 17.3457 11.1504L19.6416 13.9842C19.7162 14.0737 19.8126 14.1248 19.9132 14.1282C20.026 14.1285 20.1335 14.0658 20.2094 13.9553C20.3632 13.7376 20.3546 13.396 20.1903 13.192L17.9026 10.3619Z"
          fill="#4C4E58"
          stroke="#4C4E58"
          {...options}
        />
        <path
          d="M14.8243 0.60375C14.7191 0.503023 14.5842 0.47359 14.4602 0.524469L6.09439 3.98123H2.70091C2.25002 3.98226 1.81776 4.21995 1.49901 4.64253C1.18015 5.06494 1.00069 5.63779 1 6.23533V9.76411V9.76396C1 10.3621 1.17913 10.9358 1.49801 11.3591C1.81687 11.7825 2.24959 12.0208 2.70094 12.0216H2.83141V14.9598L2.8313 14.96C2.8313 15.2582 3.01378 15.5 3.23891 15.5H4.86919C5.09419 15.5 5.27668 15.2582 5.27668 14.96V12.0216H6.09175L14.4576 15.4747V15.4748C14.4971 15.492 14.5384 15.5004 14.5799 15.5C14.6882 15.501 14.7923 15.4443 14.8689 15.3429C14.9454 15.2414 14.9882 15.1034 14.9875 14.96V1.03948C14.9878 0.868356 14.9275 0.706838 14.8244 0.603741L14.8243 0.60375ZM1.81496 9.76391V6.23514V6.23528C1.81496 5.92394 1.90837 5.62533 2.07445 5.40522C2.24052 5.18511 2.46585 5.06134 2.7008 5.06134H5.74942V10.9413H2.7008C2.46564 10.9404 2.24031 10.8159 2.07422 10.5952C1.90825 10.3745 1.81495 10.0754 1.81495 9.76381L1.81496 9.76391ZM4.46411 14.4197H3.64904V12.0217H4.46411V14.4197ZM14.1748 14.2252L6.567 11.0817L6.56711 4.91739L14.1749 1.77389L14.1748 14.2252Z"
          fill="#4C4E58"
          stroke="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  connecteursFunnel: options => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.63636 0.909091C3.63636 0.409091 3.22727 0 2.72727 0C2.22727 0 1.81818 0.409091 1.81818 0.909091V4.54545H0V10H5.45455V4.54545H3.63636V0.909091ZM7.27273 13.6364C7.27273 14.8182 8.03636 15.8182 9.09091 16.2V20H10.9091V16.2C11.9636 15.8273 12.7273 14.8273 12.7273 13.6364V11.8182H7.27273V13.6364ZM0 13.6364C0 14.8182 0.763636 15.8182 1.81818 16.2V20H3.63636V16.2C4.69091 15.8182 5.45455 14.8182 5.45455 13.6364V11.8182H0V13.6364ZM18.1818 4.54545V0.909091C18.1818 0.409091 17.7727 0 17.2727 0C16.7727 0 16.3636 0.409091 16.3636 0.909091V4.54545H14.5455V10H20V4.54545H18.1818ZM10.9091 0.909091C10.9091 0.409091 10.5 0 10 0C9.5 0 9.09091 0.409091 9.09091 0.909091V4.54545H7.27273V10H12.7273V4.54545H10.9091V0.909091ZM14.5455 13.6364C14.5455 14.8182 15.3091 15.8182 16.3636 16.2V20H18.1818V16.2C19.2364 15.8273 20 14.8273 20 13.6364V11.8182H14.5455V13.6364Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  activableMedia: options => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>monitor</title>
        <path
          d="M21,16H3V4H21M21,2H3C1.89,2 1,2.89 1,4V16A2,2 0 0,0 3,18H10V20H8V22H16V20H14V18H21A2,2 0 0,0 23,16V4C23,2.89 22.1,2 21,2Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  monday: options => {
    return (
      <svg
        width="25"
        height="16"
        viewBox="0 0 2500 1549"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1253.86 1530.58C1144.52 1527.91 1054.31 1479.66 996.708 1378.96C937.667 1274.87 940.239 1168.31 1003.19 1066.79C1153.05 825.169 1304.88 584.889 1455.77 343.992C1486.63 294.722 1516.77 244.733 1549.06 196.389C1591.94 130.266 1658.94 83.4935 1735.78 66.0298C1812.63 48.5662 1893.26 61.7914 1960.5 102.889C2102.55 190.423 2150.07 372.484 2061.61 515.973C1880.79 810.494 1697.39 1103.58 1511.42 1395.22C1454.12 1485.42 1367.21 1528.93 1253.86 1530.58Z"
          fill="#4C4E58"
          {...options}
        />
        <path
          d="M314.75 1530.58C204.382 1527.9 114.688 1477.5 58.2184 1377.22C-9.15633e-05 1273.12 3.70285 1166.35 66.8586 1064.83C228.074 806.174 390.009 547.894 552.664 289.991C573.236 256.664 593.808 222.515 615.82 190.217C660.455 125.53 728.514 80.7538 805.585 65.368C882.657 49.9822 962.691 65.195 1028.74 107.786C1094.79 150.376 1141.68 217.001 1159.47 293.553C1177.25 370.106 1164.55 450.576 1124.05 517.928C943.839 808.917 761.16 1098.88 578.379 1388.53C519.029 1482.44 431.701 1528.93 314.75 1530.58Z"
          fill="#4C4E58"
          {...options}
        />
        <path
          d="M2199.03 940.783C2365.36 941.606 2500 1073.78 2499.69 1235.89C2499.69 1400.46 2361.45 1533.15 2193.58 1531.09C2025.71 1529.04 1893.44 1398.3 1893.64 1235.48C1893.85 1070.28 2029.01 939.754 2199.03 940.783Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  exportSegments: options => {
    return (
      <svg
        width="26"
        height="24"
        viewBox="0 0 26 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.983 1.53808C24.6619 1.20905 24.2803 0.94798 23.8601 0.76984C23.4399 0.591701 22.9894 0.5 22.5344 0.5C22.0794 0.5 21.6289 0.591701 21.2087 0.76984C20.7885 0.94798 20.4069 1.20905 20.0858 1.53808C19.7634 1.86585 19.5077 2.25536 19.3331 2.68426C19.1586 3.11316 19.0688 3.57302 19.0688 4.03744C19.0688 4.50187 19.1586 4.96172 19.3331 5.39062C19.5077 5.81953 19.7634 6.20903 20.0858 6.5368L20.1833 6.63633L17.2905 12.0995C16.4107 11.883 15.483 12.0217 14.701 12.4866L12.5233 10.2637C12.9543 9.52162 13.1049 8.64436 12.9468 7.79687C12.7887 6.94939 12.3327 6.19005 11.6646 5.66161C10.9965 5.13318 10.1623 4.87205 9.31886 4.92731C8.4754 4.98258 7.68076 5.35044 7.08434 5.96173C6.762 6.28949 6.50622 6.679 6.3317 7.1079C6.15718 7.53681 6.06734 7.99666 6.06734 8.46109C6.06734 8.92551 6.15718 9.38537 6.3317 9.81427C6.50622 10.2432 6.762 10.6327 7.08434 10.9604L7.18185 11.06L4.28903 16.5232C3.71041 16.381 3.10573 16.3928 2.53284 16.5574C1.95995 16.722 1.43803 17.0338 1.017 17.4632C0.694655 17.791 0.438883 18.1805 0.264361 18.6094C0.0898383 19.0383 0 19.4981 0 19.9626C0 20.427 0.0898383 20.8868 0.264361 21.3157C0.438883 21.7446 0.694655 22.1342 1.017 22.4619C1.33811 22.7909 1.71971 23.052 2.1399 23.2302C2.5601 23.4083 3.01061 23.5 3.46561 23.5C3.9206 23.5 4.37112 23.4083 4.79131 23.2302C5.2115 23.052 5.5931 22.7909 5.91421 22.4619C6.23656 22.1342 6.49233 21.7446 6.66685 21.3157C6.84138 20.8868 6.93122 20.427 6.93122 19.9626C6.93122 19.4981 6.84138 19.0383 6.66685 18.6094C6.49233 18.1805 6.23656 17.791 5.91421 17.4632L5.8167 17.3637L8.70952 11.9005C8.97915 11.9669 9.25557 12.0004 9.53295 12C10.1532 11.9984 10.7622 11.8306 11.299 11.5134L13.4767 13.7363C13.0866 14.4131 12.9282 15.2031 13.0262 15.9819C13.1243 16.7607 13.4734 17.4842 14.0184 18.0383C14.3396 18.3673 14.7212 18.6284 15.1413 18.8065C15.5615 18.9847 16.0121 19.0764 16.4671 19.0764C16.922 19.0764 17.3726 18.9847 17.7928 18.8065C18.2129 18.6284 18.5945 18.3673 18.9157 18.0383C19.238 17.7105 19.4938 17.321 19.6683 16.8921C19.8428 16.4632 19.9327 16.0033 19.9327 15.5389C19.9327 15.0745 19.8428 14.6146 19.6683 14.1857C19.4938 13.7568 19.238 13.3673 18.9157 13.0396L18.8181 12.94L21.711 7.47682C21.9806 7.5433 22.257 7.57671 22.5344 7.57636C22.9898 7.578 23.4409 7.4869 23.8613 7.3084C24.2818 7.1299 24.6631 6.86758 24.983 6.5368C25.3053 6.20903 25.5611 5.81953 25.7356 5.39062C25.9102 4.96172 26 4.50187 26 4.03744C26 3.57302 25.9102 3.11316 25.7356 2.68426C25.5611 2.25536 25.3053 1.86585 24.983 1.53808ZM4.68991 21.2122C4.36015 21.5172 3.92812 21.6811 3.48326 21.6699C3.03841 21.6587 2.6148 21.4734 2.30014 21.1522C1.98549 20.831 1.80388 20.3986 1.79293 19.9445C1.78198 19.4905 1.94252 19.0495 2.24131 18.7129C2.57106 18.4079 3.0031 18.244 3.44795 18.2552C3.89281 18.2664 4.31642 18.4518 4.63107 18.7729C4.94573 19.0941 5.12733 19.5265 5.13828 19.9806C5.14924 20.4347 4.9887 20.8756 4.68991 21.2122ZM8.30865 9.71076C8.14682 9.54726 8.01836 9.35262 7.93069 9.13812C7.84302 8.92362 7.79787 8.69351 7.79787 8.46109C7.79787 8.22867 7.84302 7.99855 7.93069 7.78405C8.01836 7.56955 8.14682 7.37491 8.30865 7.21141C8.55092 6.96351 8.85979 6.79456 9.19618 6.72594C9.53256 6.65732 9.88133 6.69211 10.1983 6.82591C10.5153 6.95971 10.7863 7.1865 10.977 7.47758C11.1677 7.76866 11.2694 8.11094 11.2694 8.46109C11.2694 8.81123 11.1677 9.15351 10.977 9.44459C10.7863 9.73567 10.5153 9.96246 10.1983 10.0963C9.88133 10.2301 9.53256 10.2649 9.19618 10.1962C8.85979 10.1276 8.55092 9.95866 8.30865 9.71076ZM17.6914 16.7886C17.3616 17.0936 16.9296 17.2574 16.4847 17.2463C16.0399 17.2351 15.6162 17.0497 15.3016 16.7285C14.9869 16.4074 14.8053 15.975 14.7944 15.5209C14.7834 15.0668 14.944 14.6258 15.2427 14.2892C15.5725 13.9843 16.0045 13.8204 16.4494 13.8316C16.8943 13.8427 17.3179 14.0281 17.6325 14.3493C17.9472 14.6705 18.1288 15.1029 18.1397 15.5569C18.1507 16.011 17.9901 16.452 17.6914 16.7886ZM23.7587 5.28712C23.4289 5.5921 22.9969 5.75597 22.552 5.74479C22.1072 5.73361 21.6836 5.54824 21.3689 5.22706C21.0543 4.90588 20.8727 4.4735 20.8617 4.01942C20.8508 3.56534 21.0113 3.12436 21.3101 2.78776C21.4678 2.61013 21.6592 2.46706 21.8727 2.36721C22.0861 2.26737 22.3173 2.21285 22.552 2.20695C22.7868 2.20105 23.0203 2.24389 23.2383 2.33289C23.4564 2.42189 23.6545 2.55518 23.8205 2.72467C23.9866 2.89417 24.1171 3.09633 24.2043 3.3189C24.2915 3.54146 24.3335 3.77979 24.3277 4.01942C24.3219 4.25905 24.2685 4.49498 24.1707 4.7129C24.0729 4.93081 23.9327 5.12617 23.7587 5.28712Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  handShakeIcon: options => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.2928 6.85098C20.4891 5.65475 19.9436 4.25755 19.2928 3.57809L16.4217 0.707122C15.2159 -0.489113 13.8282 0.0563701 13.1487 0.707122L11.5217 2.34357H9.04296C7.22459 2.34357 6.17185 3.30056 5.63591 4.4011L1.38666 8.65012V12.4781L0.707159 13.148C-0.489139 14.3538 0.056373 15.7414 0.707159 16.4209L3.57827 19.2918C4.09507 19.8086 4.65016 20 5.17653 20C5.85602 20 6.4781 19.6651 6.85134 19.2918L9.43535 16.6984H12.8711C14.4981 16.6984 15.3211 15.684 15.6178 14.6887C16.6993 14.4016 17.2926 13.5786 17.5319 12.7747C19.0153 12.3919 19.5704 10.9852 19.5704 9.99947V7.12851H19.0057L19.2928 6.85098ZM17.6563 9.99947C17.6563 10.4301 17.4745 10.9565 16.6993 10.9565H15.7422V11.9135C15.7422 12.3441 15.5604 12.8704 14.7852 12.8704H13.8282V13.8274C13.8282 14.2581 13.6463 14.7844 12.8711 14.7844H8.65058L5.51149 17.9233C5.21481 18.2009 5.04254 18.0382 4.93727 17.9329L2.07572 15.0811C1.79818 14.7844 1.96088 14.6122 2.06615 14.5069L3.30073 13.2628V9.43485L5.21481 7.52088V9.04249C5.21481 10.2004 5.98044 11.9135 8.08592 11.9135C10.1914 11.9135 10.957 10.2004 10.957 9.04249H17.6563V9.99947ZM17.9338 5.49206L16.3069 7.12851H9.04296V9.04249C9.04296 9.47313 8.86113 9.99947 8.08592 9.99947C7.31072 9.99947 7.12889 9.47313 7.12889 9.04249V6.17152C7.12889 5.73131 7.29158 4.25755 9.04296 4.25755H12.3065L14.4885 2.07561C14.7852 1.79809 14.9575 1.96078 15.0627 2.06604L17.9243 4.91787C18.2018 5.21453 18.0391 5.38679 17.9338 5.49206Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  menuList: options => {
    return (
      <svg
        width="20"
        height="12"
        viewBox="0 0 20 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 7.11112H2.22222V4.8889H0V7.11112ZM0 11.5556H2.22222V9.33335H0V11.5556ZM0 2.66668H2.22222V0.444458H0V2.66668ZM4.44444 7.11112H20V4.8889H4.44444V7.11112ZM4.44444 11.5556H20V9.33335H4.44444V11.5556ZM4.44444 0.444458V2.66668H20V0.444458H4.44444Z"
          fill="#4C4E58"
          {...options}
        />
      </svg>
    );
  },
  creaIcon: options => {
    return (
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.481 3.04567L12.5079 3.46109L12.0925 2.48801C11.8632 1.95086 11.2411 1.70103 10.704 1.93034L0.973087 6.08456C0.435943 6.31388 0.186109 6.93593 0.415422 7.47307L3.7388 15.2578C3.96811 15.7949 4.59017 16.0447 5.12731 15.8154L6.1004 15.4L6.51582 16.3731C6.74513 16.9102 7.36718 17.1601 7.90433 16.9308L17.6352 12.7765C18.1723 12.5472 18.4222 11.9252 18.1929 11.388L14.8695 3.60334C14.6402 3.06619 14.0181 2.81636 13.481 3.04567ZM3.19244 8.5884L5.68497 14.4269L4.71189 14.8423L1.38851 7.05765L11.1194 2.90343L11.5348 3.87652L3.75011 7.19989C3.21296 7.42921 2.96313 8.05126 3.19244 8.5884ZM17.2198 11.8035L7.48891 15.9577L4.16553 8.17298L13.8964 4.01876L17.2198 11.8035Z"
          fill="black"
          {...options}
        />
        <path
          d="M7.91561 8.87289C8.14502 9.41026 7.89531 10.032 7.35795 10.2614C6.82058 10.4908 6.19885 10.2411 5.96944 9.70374C5.74003 9.16637 5.98974 8.54464 6.5271 8.31523C7.06447 8.08582 7.68621 8.33553 7.91561 8.87289Z"
          fill="black"
          {...options}
        />
        <path
          d="M11.4449 8.51664L10.7567 11.7877L9.38497 11.2368L8.04658 14.5692L15.8313 11.2458L11.4449 8.51664Z"
          fill="black"
          {...options}
        />
      </svg>
    );
  },
  setUpAutoIcon: ({
    circleColor = 'black',
    arrowColor = 'white',
    ...options
  }) => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...options}
      >
        <rect width="18" height="18" rx="9" fill={circleColor} />
        <path
          d="M8.55279 2.89443C8.73705 2.5259 9.26295 2.5259 9.44721 2.89443L14.4225 12.8449C14.6267 13.2535 14.2213 13.6995 13.7952 13.535L9.18006 11.7537C9.0642 11.709 8.93584 11.709 8.81998 11.7537L4.20479 13.535C3.77865 13.6995 3.37326 13.2535 3.57754 12.8449L8.55279 2.89443Z"
          fill={arrowColor}
        />
      </svg>
    );
  },
  PMLDot: ({ circleColor = 'black', arrowColor = 'white' }) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="12" fill={circleColor} />
        <path
          d="M11.5528 3.56111C11.737 3.19259 12.263 3.19259 12.4472 3.56111L19.4225 17.5116C19.6267 17.9202 19.2213 18.3662 18.7952 18.2017L12.1801 15.6485C12.0642 15.6037 11.9358 15.6037 11.82 15.6485L5.20479 18.2017C4.77865 18.3662 4.37326 17.9202 4.57754 17.5116L11.5528 3.56111Z"
          fill={arrowColor}
        />
      </svg>
    );
  },
  right: options => {
    return (
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 2.29429L11.2525 9.89286L1.5 17.4914L4.12376 19.5357L16.5 9.89286L4.12376 0.25L1.5 2.29429Z"
          fill="white"
          {...options}
        />
      </svg>
    );
  },
  left: options => {
    return (
      <svg
        width="9"
        height="13"
        viewBox="0 0 9 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.20492 1.91L6.79492 0.5L0.794922 6.5L6.79492 12.5L8.20492 11.09L3.62492 6.5L8.20492 1.91Z"
          fill="black"
          {...options}
        />
      </svg>
    );
  },
  setup: ({ enabled = false, ...options }) => {
    return (
      <svg
        width={options?.width || '27'}
        height={options?.height || '21'}
        viewBox="0 0 27 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="27"
          height="21"
          rx="5"
          fill={enabled ? '#3EAC7B' : '#F5F5F5'}
        />
        <rect x="4.5" y="1.5" width="18" height="18" rx="9" fill="white" />
        <path
          d="M13.0528 4.39443C13.237 4.0259 13.763 4.0259 13.9472 4.39443L18.9225 14.3449C19.1267 14.7535 18.7213 15.1995 18.2952 15.035L13.6801 13.2537C13.5642 13.209 13.4358 13.209 13.32 13.2537L8.70479 15.035C8.27865 15.1995 7.87326 14.7535 8.07754 14.3449L13.0528 4.39443Z"
          fill={enabled ? '#3EAC7B' : '#808080'}
        />
      </svg>
    );
  },
  cancelSetup: ({ enabled = false, ...options }) => {
    return (
      <svg
        fill={enabled ? '#F35959' : '#808080'}
        width={options?.width || '800'}
        height={options?.height || '800'}
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 297 297"
        xmlSpace="preserve"
        {...options}
      >
        <path
          d="M148.5,0C66.486,0,0,66.486,0,148.5S66.486,297,148.5,297S297,230.514,297,148.5S230.514,0,148.5,0z M213.292,190.121
     c0,12.912-10.467,23.379-23.378,23.379H106.67c-12.911,0-23.378-10.467-23.378-23.379v-83.242c0-12.912,10.467-23.379,23.378-23.379
     h83.244c12.911,0,23.378,10.467,23.378,23.379V190.121z"
        />
      </svg>
    );
  },
  folder: options => {
    return (
      <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
          {...options}
        />
      </svg>
    );
  },
  ...logo_noel2023
};
